import {useSelector} from 'react-redux';

export default () =>
	useSelector(({userPreferences}) => {
		const isValidUserId = userPreferences.userId && userPreferences.userId !== '00000000-0000-0000-0000-000000000000';
		return {
			isNewUser: !isValidUserId,
			isPreferencesLoaded: userPreferences.isPreferencesLoaded,
			userId: userPreferences.userId,
			firstName: userPreferences.firstName,
			lastName: userPreferences.lastName,
			languageISOCode: userPreferences.languageISOCode,
			dateFormat: userPreferences.dateFormat,
			numberFormat: userPreferences.numberFormat,
			timeZoneISOCode: userPreferences.timeZoneISOCode,
			theme: userPreferences.theme
		};
	});
